import React from 'react';
import { createUseStyles } from 'react-jss';
import Text from './Text';

export interface FullPageErrorProps {
  title?: string;
  description?: string;
  footer?: JSX.Element;
}

const FullPageError: React.FC<FullPageErrorProps> = ({
  title,
  description,
  footer,
}) => {
  const classes = useSetyles();
  return (
    <div className={classes.wrapper}>
      <div className={classes.imageWrapper}>
        <img
          className={classes.image}
          src={`${process.env.PUBLIC_URL}/assets/img/404.svg`}
          alt="404"
        />
      </div>
      <Text as="h3" uppercase>
        {title}
      </Text>
      <Text as="p">{description}</Text>
      {footer}
    </div>
  );
};

const useSetyles = createUseStyles({
  wrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imageWrapper: {
    maxWidth: '480px',
    marginBottom: '20px',
  },
  image: {
    width: '100%',
  },
});

export default FullPageError;
